import React, { lazy, Suspense } from 'react';

const AmericanBanner = lazy(() => import('./AmericanBanner'));
const GoldBanner = lazy(() => import('./GoldBanner'));
const DreamBanner = lazy(() => import('./DreamBanner'));
const SuperBanner = lazy(() => import('./SuperBanner'));

const Banner = ({ campaign }) => (
    <Suspense fallback={<></>}>
		{(campaign === 'american') && <AmericanBanner />}
		{(campaign === 'gold') && <GoldBanner />}
		{(campaign === 'dream') && <DreamBanner />}
		{(campaign === 'super') && <SuperBanner />}
	</Suspense>
);

export default Banner;